import { render, staticRenderFns } from "./create-admin-modal.vue?vue&type=template&id=97562676"
import script from "./create-admin-modal.vue?vue&type=script&lang=js"
export * from "./create-admin-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports